export default "__VITE_ASSET__001faed2__"